export const EVENTS_TOGGLE_STORAGE_KEY = 'eventTogglePreferences';
export const MAP_LAYER_PROPS_STORAGE_KEY = 'mapLayerProperties';
export const MAP_OPTION_PROPS_STORAGE_KEY = 'mapOptionProperties';
export const VESSEL_MULTISELECTOR_PREFERENCES_STORAGE_KEY =
  'vesselMultiSelectorPreferences';
export const FILTER_STORAGE_KEY = 'filters';
export const WELCOME_PAGE_PREFS_STORAGE_KEY = 'welcomePagePreferences';
